import MagicButton from '@components/buttons/magicButton';
import { SOCIAL_MEDIA } from '@constants/index';

const Footer = () => {
  return (
    <footer className="w-full pt-20 pb-10" id="contact">
      <div className="w-full absolute left-0 -bottom-72 min-h-96">
        <img src="/footer-grid.svg" alt="footer" className="w-full h-full opacity-50" />
      </div>

      <div className="flex flex-col items-center text-center">
        <h1 className="text-3xl heading lg:max-w-[45vw]">
          Time to build <span className="text-purple">amazing software solutions</span> together.
        </h1>
        <p className="text-1xl heading lg:max-w-[45vw] mt-5">
          Reach out me today, I&apos;ll be pleased to help you achieve your goals.
        </p>

        <div className="mt-4">
          <a href="mailto:codexmaker.hiring@gmail.com">
            <MagicButton title="Let's get in touch" />
          </a>
        </div>

        <div className="flex mt-16 md:flex-row flex-col justify-between items-center">
          <p className="md:text-base text-sm md:font-normal font-light text-1xl heading">
            Copyright &copy; {new Date().getFullYear()} CodexMaker. All rights reserved.
          </p>
        </div>
        <div className="flex items-center md:gap-3 gap-6 z-10 cursor-pointer mt-10">
          {SOCIAL_MEDIA.map((item) => (
            <div key={item.id}>
              <img
                onClick={() => window.open(item.link, '_blank')}
                src={item.img}
                alt={item.img}
                width={20}
                height={20}
              />
            </div>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
